import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigurationDataProvider } from '../configuration-data-provider';
import { SharedDataProvider } from '../shared-data-provider';
import {Receipt} from '../dto/receipt';

/*
  Generated class for the ReceiptProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class ReceiptProvider {
  headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });

  constructor(private http: HttpClient, private config: ConfigurationDataProvider, private shared: SharedDataProvider) { }

  public list() {
    console.log(JSON.stringify(this.shared.getTokenAuthData()));
    return this.http.post(this.config.receiptURL+"list", JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public save(receipt : Receipt) {
    console.log('Push receipt to insert method of service.');
    receipt.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(receipt));
    return this.http.post(this.config.receiptURL+"new", JSON.stringify(receipt), {headers: this.headers});
  }

  public update(receipt : Receipt) {
    console.log('Push receipt to insert method of service.');
    receipt.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(receipt));
    return this.http.put(this.config.receiptURL+"id/"+receipt.id, JSON.stringify(receipt), {headers: this.headers});
  }

  public qryReceipt(id : number) {
    return this.http.post(this.config.receiptURL+"id/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public delete(id : number) {
    console.log('Delete receipt '+ id);
    return this.http.post(this.config.receiptURL+"del/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public load(first : number, pageSize: number, sortField : string, sortOrder: string, filterSet : any) {
    let paramSet : any = {};
    paramSet.credentials = this.shared.getTokenAuthData();
    paramSet.first = first;
    paramSet.pageSize = pageSize;
    paramSet.sortField = sortField;
    paramSet.sortOrder = sortOrder;
    paramSet.filters = filterSet;

    console.log("Load receipts filtered: "+JSON.stringify(paramSet));

    return this.http.post(this.config.receiptURL+"filter", JSON.stringify(paramSet), {headers: this.headers});
  }

  public book (id : number, receiptId : number, barcode : string, weight: number, binTypeId: number, locationId : number, articleId: number, quantity : number, reservationCode: string) {
    let paramSet : any = {};
    paramSet.credentials = this.shared.getTokenAuthData();
    paramSet.barcode = barcode;
    paramSet.weight = weight;
    paramSet.binTypeId = binTypeId;
    paramSet.locationId = locationId;
    paramSet.articleId = articleId;
    paramSet.quantity = quantity;
    paramSet.reservationCode = reservationCode;
    paramSet.receiptId = receiptId;

    return this.http.post(this.config.receiptURL+"book/"+id, JSON.stringify(paramSet), {headers: this.headers});
  }

  public finish(id : number) {
    console.log('Finish receipt '+ id);
    return this.http.post(this.config.receiptURL+"finish/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }
}




// WEBPACK FOOTER //
// ./src/providers/receipt/receipt.ts